import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';

const EvaluationBreakdown = ({ dimensionScores }) => {
  // HS category weights matching init.sql seed
  const pieData = [
    { name: 'Character',            value: 35, color: '#7E57C2' },
    { name: 'Academic Profile',     value: 20, color: '#546E7A' },
    { name: 'Athletic Ability',     value: 20, color: '#00E676' },
    { name: 'Position Performance', value: 15, color: '#FFB300' },
    { name: 'Projection',           value: 10, color: '#00D4FF' },
  ];

  return (
    <div className="panel-card fade-in">
      <h2 className="text-white font-bold text-lg mb-4">Evaluation Breakdown</h2>
      <ResponsiveContainer width="100%" height={280}>
        <PieChart>
          <defs>
            <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="0" dy="4" stdDeviation="4" floodOpacity="0.3"/>
            </filter>
          </defs>
          <Pie
            data={pieData}
            cx="50%"
            cy="45%"
            innerRadius={0}
            outerRadius={90}
            paddingAngle={2}
            dataKey="value"
            label={({ value }) => `${value}%`}
            labelLine={false}
            filter="url(#shadow)"
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Legend
            verticalAlign="bottom"
            height={36}
            iconType="circle"
            formatter={(value) => (
              <span style={{ color: '#B0BEC5', fontSize: '11px' }}>{value}</span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EvaluationBreakdown;
